import React from 'react'
import { useSelector } from 'react-redux'
import { BiUser } from 'react-icons/bi'
import { ApplicationState } from '../../store'
import { Typography } from './Typography'
import styled from '../../utils/styled'

const UserIconItem = styled(BiUser)`
  font-size: ${props => props.theme.iconSizes.md};
  color: ${({ theme }) => theme.colors.black};
`

export const UserIcon: React.FC = () => {
  const { isLoggedIn: isUserLoggedIn, userData } = useSelector((state: ApplicationState) => state.user)

  const getLoggedInUserInitials = () => {
    if (!userData) return ''
    return `${userData.vorname.charAt(0)}${userData.nachname.charAt(0)}`
  }

  return isUserLoggedIn ? (
    <Typography variant="body1" margin="0">
      {getLoggedInUserInitials()}
    </Typography>
  ) : (
    <UserIconItem />
  )
}
